/* eslint-disable */
import requestRaw from "@/utils/requestRaw";
import requestPublic from "@/utils/requestPublic";
import requestDownload from "@/utils/requestDownload";
import requestUpload from "@/utils/requestUpload";
import { APICoreV2 } from "@/utils/servicesApi";

// APICoreV2() sudah mengembalikan prefix /go-omni-v2.
const BASE_URL = APICoreV2() + "/form";
const PUBLIC_BASE_URL = APICoreV2() + "/public-form";

function get(path, params) {
  return requestRaw({
    url: BASE_URL + path,
    method: "GET",
    params: params || {},
    // Error ditangani oleh halaman agar pesan 500 tidak membocorkan detail backend.
    silent: true
  });
}

function post(path, data) {
  return requestRaw({
    url: BASE_URL + path,
    method: "POST",
    data: data,
    silent: true
  });
}

export function listWaajoForms(params) {
  return get("/list", params);
}

export function detailWaajoForm(id) {
  return post("/detail", { id: id });
}

export function storedWaajoForm(payload) {
  return post("/stored", payload);
}

export function updateWaajoForm(payload) {
  return post("/update", payload);
}

export function publishWaajoForm(id) {
  return post("/publish", { id: id });
}

export function deactivateWaajoForm(id) {
  return post("/deactivate", { id: id });
}

export function deleteWaajoForm(id) {
  return post("/delete", { id: id });
}

export function listWaajoFormResponses(params) {
  return get("/responses/list", params);
}

export function detailWaajoFormResponse(id) {
  return post("/responses/detail", { id: id });
}

export function statsWaajoFormResponses(formId) {
  return get("/responses/stats", { form_id: formId });
}

export function exportWaajoFormResponses(formId) {
  return requestDownload({
    url: BASE_URL + "/responses/export",
    method: "GET",
    params: { form_id: formId },
    responseType: "blob"
  });
}

export function getWaajoFormNotificationConfig(formId) {
  return get("/notifications", { form_id: formId });
}

export function updateWaajoFormNotificationConfig(payload) {
  return post("/notifications/update", payload);
}

export function uploadWaajoFormImage(formId, file) {
  const formData = new FormData();
  formData.append("form_id", formId);
  formData.append("file", file);
  return requestUpload({
    url: BASE_URL + "/image/upload",
    method: "POST",
    data: formData
  });
}

export function getPublicFormDefinition(formId) {
  return requestPublic({
    url: PUBLIC_BASE_URL + "/" + encodeURIComponent(formId || ""),
    method: "GET"
  });
}

export function submitPublicForm(formId, answers, recaptchaToken) {
  // Catatan kontrak: dokumentasi backend saat ini belum menetapkan nama
  // properti token reCAPTCHA. Frontend mengirim token top-level
  // `recaptcha_token`; properti ini perlu disepakati dan diverifikasi backend.
  return requestPublic({
    url:
      PUBLIC_BASE_URL +
      "/" +
      encodeURIComponent(formId || "") +
      "/submit",
    method: "POST",
    data: {
      answers: answers,
      recaptcha_token: recaptchaToken
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/waajoForms.js